import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GlobalService } from './_common/global';
import { Title } from '@angular/platform-browser';
import { ApiService } from './_services/api.service';
import { ApiDocService } from '@services/api-doc.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  pageLoad = false;
  sessionLoad=false;
  constructor(private _apidocService: ApiDocService,private _apiService: ApiService, public _global: GlobalService, private titleService: Title, public router: Router) {
  }

  ngOnInit() {
    
    this._apidocService.apidoc({}).subscribe(
      doc => {
        this._global.APIDOC = doc['apis'];
        this.pageLoad = true;
      },
      error => {
        console.log("Subscription error:", error);
      }
    );

    if (this._global.getToken()) {
      this.sessionLoad=true;
    }
    this._apiService.getMemberSession().subscribe(
      memberSession => {
        let response = this._global.getVal(memberSession, 'response', '');
        if (response != null && response != undefined && (response != '' || response != {})) {
          localStorage.removeItem(this._global.SESSION_KEY);
          localStorage.setItem(this._global.SESSION_KEY, JSON.stringify(response));
          this.sessionLoad=true;
        }
        else {
          console.log("ERROR : memberSession :", memberSession);
        }
      },
      error => {
        console.log("Subscription error:", error);
        this._apiService.handleError(error);
      }
    );
   
  }

}